let productData = {};
const url = new URL(window.location.href);
const productVariants = document.querySelector(
	"product-variants > .product-variants"
);
const blends = document.querySelectorAll(
	'.product-variant[data-name*="coffee:"] input[type="radio"]'
);
const formatter = new Intl.NumberFormat("en-AU", {
	style: "currency",
	currency: "AUD",
});
let temp = [];

const updateBlendPrices = () => {
	const selectedVariants = Array.from(
		document.querySelectorAll(
			'.product-variants .product-variant:not([data-name*="coffee:"], [data-name*="coffee-type"]) input:checked'
		)
	).map((variant) => {
		return variant?.value;
	});

	blends.forEach((blend, index) => {
		temp = [];
		temp.push(...selectedVariants);
		temp.push(blend.value);
		const variant = productData.variants.filter(({ options }) => {
			return JSON.stringify(temp) === JSON.stringify(options);
		});

		const priceElement = blend.parentElement.querySelector("span.price");
		priceElement.classList.remove("active");
		priceElement.innerText = formatter.format(variant[0]?.price / 100);

		setTimeout(() => {
			priceElement.classList.add("active");
		}, 250);
	});
};

fetch(`${url.pathname}.js`)
	.then((res) => res.json())
	.then((data) => {
		productData = data;
	})
	.finally(() => {
		updateBlendPrices();
	});

const selections = Array.from(
	document.querySelectorAll(
		'.product-variants .product-variant:not([data-name*="coffee:"]) input[type="radio"], .product-variants .product-variant:not([data-name="coffee-type"]) input[type="radio"]'
	)
).map((selection) => {
	selection.addEventListener("click", updateBlendPrices);
});
